module.exports = __webpack_public_path__ + "img/服务中心.48da2e14.png";